import React from 'react';
import './css/index.scss';

const OPERATION_TYPES = [
  { value: 'parsingEventsFromKontramarka', label: 'Парсинг Kontramarka' },
  { value: 'parsingEventsFromFienta', label: 'Парсинг Fienta' },
  { value: 'parsingEventsFromEventim', label: 'Парсинг Eventim' },
];

function SelectOperationType({ setValue, setTempComponentState }) {
  const handleTypeClick = (type) => {
    setValue(type);
    setTempComponentState(null);
  };

  return (
    <div className="temp_container">
      <p className="temp_container_title">Выберите тип операции</p>
      <div className="temp_container_scroll">
        {OPERATION_TYPES.map((item) => (
          <div
            key={item.value}
            className="temp_container_item"
            onClick={() => handleTypeClick(item.value)}
          >
            <p className="temp_container_item_text">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SelectOperationType;
